import React, { useState, useEffect } from 'react';
import Enums from '../../enums';
import { Container, Row, Col, Button } from 'react-bootstrap';
// import { Link } from 'react-router-dom';
import { FaCloudDownloadAlt } from 'react-icons/fa';
import { CSVLink } from "react-csv";
import '../../css/ListView.scss';

export default function ListDownloadButton(props) {
    /*
    <ListView list={list} 
        fields={fields}
        onRowClicked={onListViewClicked}/>
    fields:
        ["a","b",...]
    list:
        [
            {
                key: "a key",
                data: [
                    a list
                ]
            }, {
                key: "b key",
                data: [b list]
            },
            ...
        ]
    */


    const [exportRows, seteexportRows] = useState([]);
    const [isWaitingForUpdate, setIsWaitingForUpdate] = useState(true);
    const [downloadLinkReady, setDownloadLinkReady] = useState(false);

    useEffect(() => {
        // console.log("updated", isFetched);
        if (true == isWaitingForUpdate) {
            genDownloadLink();
        }
        setIsWaitingForUpdate(true);
    }, [isWaitingForUpdate]);

    // componentDidUpdate(prevProps, prevState) {
    //     console.log("[componentDidUpdate]", this.state.isWaitingForUpdate)
    //     // console.log(prevProps.list, this.props.list)
    //     if ((true == this.state.isWaitingForUpdate
    //         && prevProps.list == null || prevProps.list.length == 0)
    //         && this.props.list != null && this.props.list.length > 0) {
    //         // console.log("!!");
    //         this.setState({ isWaitingForUpdate: false })
    //         this.genDownloadLink();
    //     }
    // }

    function propComparatorInt(index, asc) {
        if (asc) {
            return function (a, b) {
                var a = parseInt(a.data[index]);
                var b = parseInt(b.data[index]);
                if (a === b) return 0;
                if (a > b) return 1;
                return -1;
            }
        }
        return function (a, b) {
            var a = parseInt(a.data[index]);
            var b = parseInt(b.data[index]);
            if (a === b) return 0;
            if (a < b) return 1;
            return -1;
        }
    }

    function genDownloadLink() {
        // console.log("[!]", props);
        if (null==props) {
            console.log("[!] no props");
            return;
        }
        let { list } = props;
        const tmpExportRows = [];

        list.sort(propComparatorInt(1, false));
        // download all data in once
        for (let i = 0; i < list.length; i++) {
            const obj = list[i],
                ary = obj.data,
                row = [];
            for (let j in ary) {
                // console.log(j,ary);
                let isHide = false;

                if (false == isHide) {
                    row.push(ary[j]);
                }
            }
            tmpExportRows.push(row);
        }

        // console.log("[!]", tmpExportRows);

        seteexportRows(tmpExportRows);
        setDownloadLinkReady(true);
    }

    function render() {
        // console.log(this.props);
        let { list, fields } = props;
        // const { onClick, onShowRowChange, onPageChange, onHeaderClick,
        //     onFilterChange, filterFunc, propComparator, propComparatorInt } = this;
        // console.log(showRows);

        if (null == list || null == list.length || 0 >= list.length) {
            return (<Button disable={true}>No Data</Button>);
        }

        try {
            const export_header_tmp = [];
            const t_headers = [];
            for (const index in fields) {
                t_headers.push(<th key={index} data-k={index}>{fields[index]}</th>);
                export_header_tmp.push(fields[index]);
            }

            let t_body = [];
            if (list.length > 0) {
                for (let i = 0; i < list.length && i<5; i++) {
                    const obj = list[i],
                        ary = obj.data,
                        tds = [];
                    for (let j in ary) {
                        tds.push(<td key={j}>{ary[j]}</td>);
                    }
                    t_body.push(<tr key={i}>{tds}</tr>);
                }
            }


            let filename = props.fileName ? props.fileName + ".csv" : "ezc_export_" + new Date().toISOString().slice(0, 10) + ".csv";

            return (
                <>
                    <Button variant="link" size="sm" disabled={!downloadLinkReady}>
                        {downloadLinkReady ? (
                            <span className="glyphicon glyphicon-download-alt">
                                <CSVLink disabled={exportRows != null}
                                    headers={export_header_tmp}
                                    data={exportRows}
                                    filename={filename}>下載報表&nbsp;<FaCloudDownloadAlt style={{fontSize: "x-large"}}/>
                                </CSVLink>
                            </span>
                        ) : (
                            <span className="glyphicon glyphicon-download-alt">Loading..</span>
                        )}
                    </Button>
                    <hr/>
                    <p>樣本數: {props.sampleNum}</p>
                    <p>{props.title}</p>
                    <table className="table table-hover">
                        <thead><tr>{t_headers}</tr></thead>
                        <tbody>{t_body}</tbody>
                    </table>
                    {list.length>5?<p>完整資料請至 填答結果下載，此列出前五項</p>:null}
                </>
            );
        } catch (e) {
            console.log(e);
            return (<div>error</div>);
        }
    }
    return render();
}